module.exports = __webpack_public_path__ + "assets/images/Doller.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/Doller.png
// module id = 1354
// module chunks = 1